var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticStyle: { height: "100% !important" },
      attrs: { fluid: "", "grid-list-md": "", id: "ada" }
    },
    [
      _c(
        "v-dialog",
        {
          attrs: { transition: "dialog-bottom-transition" },
          model: {
            value: _vm.showInfo,
            callback: function($$v) {
              _vm.showInfo = $$v
            },
            expression: "showInfo"
          }
        },
        [
          _c(
            "v-card",
            { staticStyle: { width: "300px" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticStyle: {
                        "font-size": "17px",
                        "margin-left": "10px !important"
                      }
                    },
                    [_vm._v("\n          Modelos Gps Habilitados\n        ")]
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c("table", [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Marca")]),
                    _c("th", [_vm._v("Modelo")])
                  ])
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.modelsList, function(model) {
                    return _c("tr", { key: model.nom_modelo }, [
                      _c("td", [_vm._v(_vm._s(model.nom_marca))]),
                      _c("td", [_vm._v(_vm._s(model.nom_modelo))])
                    ])
                  }),
                  0
                )
              ]),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        "data-testid": "v-btn--cancelar",
                        color: "white",
                        depressed: "",
                        small: ""
                      },
                      on: {
                        click: function($event) {
                          _vm.showInfo = false
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "#526da5" } }, [
                        _vm._v("Cerrar")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-tabs",
        {
          attrs: { left: "", color: "transparent" },
          model: {
            value: _vm.tabmodel,
            callback: function($$v) {
              _vm.tabmodel = $$v
            },
            expression: "tabmodel"
          }
        },
        [
          _c(
            "v-tab",
            {
              attrs: { href: "#cc_sitio" },
              on: {
                click: function($event) {
                  return _vm.getModels("cc_sitio")
                }
              }
            },
            [_vm._v("Sitio (Entrada/Salida)")]
          ),
          _c(
            "v-tab",
            {
              attrs: { href: "#cc_tag" },
              on: {
                click: function($event) {
                  return _vm.getModels("cc_tag")
                }
              }
            },
            [_vm._v("Tag (Bluetooth)")]
          ),
          _c(
            "div",
            { staticStyle: { "margin-left": "auto" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", flat: "" },
                  on: {
                    click: function($event) {
                      _vm.showInfo = true
                    }
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticStyle: { "font-size": "25px" },
                      attrs: { small: "" }
                    },
                    [_vm._v("touch_app")]
                  ),
                  _c(
                    "h3",
                    {
                      staticStyle: { "font-size": "16px", "font-weight": "500" }
                    },
                    [_vm._v("\n          Modelos Gps habilitados\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider", { staticStyle: { "margin-bottom": "1%" } }),
      _vm.tabmodel === "cc_sitio"
        ? _c("CortaCorriente", { attrs: { tipocc: "cc_sitio" } })
        : _vm._e(),
      _vm.tabmodel === "cc_tag"
        ? _c("Tag", { attrs: { tipocc: "cc_tag" } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }